module.exports = __webpack_public_path__ + "static/img/home-rank-card.17fbf6b5.png";